type TArrayPredicate = (value: unknown, index: number, array: unknown[]) => unknown

const at = function at(this: unknown[], index: number) {
    const relative = Math.trunc(index) || 0
    const position = relative < 0 ? this.length + relative : relative

    return position < 0 || position >= this.length ? undefined : this[position]
}

const findLast = function findLast(this: unknown[], predicate: TArrayPredicate, thisArg?: unknown) {
    for (let index = this.length - 1; index >= 0; index -= 1) {
        if (predicate.call(thisArg, this[index], index, this)) {
            return this[index]
        }
    }

    return undefined
}

if (typeof Array.prototype.at !== 'function') {
    Object.defineProperty(Array.prototype, 'at', {
        value: at,
        writable: true,
        configurable: true,
    })
}

if (typeof Array.prototype.findLast !== 'function') {
    Object.defineProperty(Array.prototype, 'findLast', {
        value: findLast,
        writable: true,
        configurable: true,
    })
}

export {}
